module.exports = __webpack_public_path__ + "img/mall1.f1906903.png";